import { render } from "./ResonancePage.vue?vue&type=template&id=b82d1bb6&scoped=true"
import script from "./ResonancePage.vue?vue&type=script&lang=js"
export * from "./ResonancePage.vue?vue&type=script&lang=js"

import "./ResonancePage.vue?vue&type=style&index=0&id=b82d1bb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b82d1bb6"]])

export default __exports__